import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import PropTypes from 'prop-types';
import {ezprOrange} from '../../_helpers';
import {requestStores} from '../../ListOfPREditors.brick.jsx';

/**
 * A popup allowing the requester to send a message explaining why he rejected the request
 * @param {RejectPRPopup.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function RejectPRPopup(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const [rejectionMsg, setRejectionMsg] = useRequestStore((state) => [state.rejectionMsg, state.setRejectionMsg]);

    const handleCommentChange = (event) => {
        setRejectionMsg(event.target.value);
    };

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="reject-pr-popup"
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: ezprOrange, width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>cancel</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{'You rejected this request.'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please insert a comment explaining why you rejected this request.
                            This comment will be shown to the spender.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            fullWidth
                            variant={'outlined'}
                            multiline
                            rows={3}
                            label={'Your comment'}
                            sx={{marginTop: '15px'}}
                            defaultValue={rejectionMsg}
                            onBlur={handleCommentChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onCancel}>
                            Cancel
                        </Button>
                        <Button onClick={props.onClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

RejectPRPopup.propTypes = {
    prTag: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
